/**
 * Pure helpers used by DemoToolkit. No React, no I/O — safe to import
 * from anywhere.
 */

export const formatClock = (ms) => {
  const total = Math.floor(ms / 1000);
  const mm = String(Math.floor(total / 60)).padStart(2, '0');
  const ss = String(total % 60).padStart(2, '0');
  return `${mm}:${ss}`;
};

export const msToSrt = (ms) => {
  const total = Math.max(0, Math.floor(ms));
  const hh = String(Math.floor(total / 3600000)).padStart(2, '0');
  const mm = String(Math.floor((total % 3600000) / 60000)).padStart(2, '0');
  const ss = String(Math.floor((total % 60000) / 1000)).padStart(2, '0');
  const mmm = String(total % 1000).padStart(3, '0');
  return `${hh}:${mm}:${ss},${mmm}`;
};

export const describeTarget = (el) => {
  if (!el || el.nodeType !== 1) return null;
  let node = el;
  let hops = 0;
  while (node && hops < 6) {
    const testid = node.getAttribute?.('data-testid');
    const tag = (node.tagName || '').toLowerCase();
    const isInteractive =
      testid || tag === 'button' || tag === 'a' ||
      node.getAttribute?.('role') === 'button' ||
      tag === 'input' || tag === 'select';
    if (isInteractive) {
      const text = (node.innerText || node.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);
      return {
        testid: testid || null,
        tag,
        text: text || (node.getAttribute?.('aria-label') || node.getAttribute?.('title') || '').slice(0, 80),
      };
    }
    node = node.parentElement;
    hops += 1;
  }
  return null;
};

export const downloadTextFile = (name, text, mime = 'text/plain;charset=utf-8') => {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const result = reader.result || '';
    const commaIdx = String(result).indexOf(',');
    resolve(commaIdx >= 0 ? String(result).slice(commaIdx + 1) : String(result));
  };
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});
